<template>
  <v-app-bar
v-if="isAuthenticated()" flat
class="headerbar">
    <v-btn>
      <v-img alt="ALTTEXT MISSING" role="link" tabindex="0" @keydown.enter="goHome()"
        src="/images/memasHome.png"
        class="logo"
        width="50px"
        @click="goHome()"
      />
    </v-btn>
    <!--
      <v-toolbar-items v-for="(item, index) in getNavItems()" :key="index">
      <v-btn text :aria-label="item.a11y" @click="navigate(item, index)">
        <div :class="getNavClass(index)" v-text="item.name" />
      </v-btn>
    </v-toolbar-items>
    -->
    <v-spacer />
    <!--
    <v-spacer />
     <v-toolbar-title v-else>
      <span class="center">{{ $t('gui.adminof') }} {{ getPrimaryUserData().pu_displayName }}</span>
    </v-toolbar-title>
    
    <HelpInformation color="var(--color-brand-text)" />
    -->
    <!--
        <v-avatar v-if="gotUser" color="var(--color-brand-300)">
            <v-img alt="ALTTEXT MISSING"
                v-if="userIcon !== ''"
                :src="getImageUrl(userIcon)"
                width="20vw"
            />
            <span v-else color="var(--color-white)">
                {{ getAvatarName(true) }}
            </span>
        </v-avatar>
        -->
    <v-btn
      v-if="sjekkKardeUser() || sjekkAdminUsers()"
      icon="mdi-cog-outline"
      :class="getNavClass(10)"
      @click="doSettings()"
    />
    <v-btn
:class="getNavClass(20)" icon
:loading="isLoading" @click="logout()">
      <v-icon>mdi-logout-variant</v-icon>
      <v-tooltip activator="parent">
        {{ $t('tooltip.logout') }}
      </v-tooltip>
    </v-btn>
  </v-app-bar>
  <v-app-bar
v-else flat
class="headerbar2">
    <template #image>
      <v-img alt="ALTTEXT MISSING"
        src="/images/MEMAS-2.svg"
        height="8vh"
        style="margin-top: 5vh; margin-bottom: 2vh"
      />
    </template>
  </v-app-bar>
</template>

<!--
<script setup>
const callback = (response) => {
  // This callback will be triggered when the user selects or login to
  // his Google account from the popup
  console.log('Handle the response', response)
}
</scrip>
-->

<script>
// import {mapState} from 'vuex'
import { mapActions, mapState, mapGetters } from 'pinia'

import { adminStore } from '@/stores/adminstore.js'
import { userStore } from '@/stores/userstore.js'
import { imageStore } from '@/stores/imagestore.js'

// import { googleLogout } from 'vue3-google-login'
// import { decodeCredential } from 'vue3-google-login'
// import GoogleLogin from '@/components/menues/GoogleLogin.vue'
// import GoogleLogout from '@/components/menues/GoogleLogout.vue'

export default {
  name: 'NavigationSystem',

  /*
  setup() {
    const adminStore = useAdminwebStore()
    return {
      // you can return the whole store instance to use it in the template
      adminStore
    }
  },
  */
  components: {
    //  NavIcon: () => import('@/components/menues/NavIcon'),
    // GoogleLogin,
    // GoogleLogout
  },
  props: {
    location: { type: String, default: 'top' }
  },

  data() {
    return {
      notRegistered: true,
      isLoading: false,
      userIcon: '',
      gotUser: false
    }
  },
  computed: {},
  async mounted() {
    console.log('mounted got called...')
    this.setActiveNavItem(2)
    await this.getUserAvatarIcon()
  },
  methods: {
    ...mapState(adminStore, ['getActiveNavItem', 'getUiLevel', 'getLang']),
    ...mapActions(adminStore, ['setActiveNavItem', 'setUiLevel', 'setLang']),
    ...mapActions(userStore, [
      'logoutUser',
      'findSecondaryUser',
      'setDisplayName',
      'processJWT',
      'sjekkKardeUser',
      'sjekkAdminUsers'
    ]),
    ...mapGetters(userStore, [
      'getSecondaryUserData',
      'getLoggedIn',
      'getDisplayName',
      'getSecondaryUserData',
      'getPrimaryUserData',
      'getEmail'
    ]),
    ...mapActions(imageStore, ['getImageUrl']),
    /*
    async verifyCredentials(credential) {
      const ticket = await client.verifyIdToken({
        idToken: credential
      })
      const payload = ticket.getPayload()
      return payload
    },
    */
    imageError(err) {
      window.alert(err)
    },
    goHome() {
      this.$router
        .push({
          name: 'LoggedIn'
        })
        .catch(() => {})
    },
    getUserAvatarIcon() {
      console.log('getUserAvatarIcon got called')
      let suUser = this.getSecondaryUserData()
      console.log('SECONDARY USER (%J)', suUser)
      this.userIcon = suUser.su_picture || ''
      this.gotUser = true
    },
    isAuthenticated() {
      return this.getLoggedIn()
    },
    getAvatarName(avatar) {
      if (avatar) {
        let name = this.getDisplayName() || 'No Name'
        let nameParts = name.split(' ')
        console.log('NAMEPARTS (%s) (%s)', nameParts[0], nameParts[1])
        if (nameParts.length > 1) {
          return (
            nameParts[0].substring(0, 1).toUpperCase() +
            nameParts[1].substring(0, 1).toUpperCase()
          )
        } else if (nameParts.length > 0) {
          return nameParts[0].substring(0, 1).toUpperCase()
        } else {
          return ''
        }
      } else {
        return this.getDisplayName()
      }
    },
    getNavClass(navIndex) {
      if (this.getActiveNavItem() === navIndex) {
        return 'label active'
      } else {
        return 'label'
      }
    },
    navigate(item, itemIndex) {
      console.log('NAVIGATE got called !')
      console.log(item)
      item.index = itemIndex
      this.setActiveNavItem(item)
      this.$router
        .push({
          name: item.pathName
        })
        .catch(() => {})
    },
    doSettings() {
      var newPath = '/settings/'
      console.log('++++++++++ NEW PATH (' + newPath + ')')
      this.setActiveNavItem(10)
      this.activeMenyItem = 10
      this.$router
        .push({
          name: 'MemasSettings'
        })
        .catch(() => {})
    },
    getNavItems() {
      return [
        {
          /* memas navigation */
          index: 0,
          name: this.$t('nav.nav0'),
          a11y: this.$t('nav.nav0'),
          pathName: 'LoggedIn',
          uiLevel: this.getUiLevel()
        },
        {
          /* 1 */
          index: 0,
          name: this.$t('nav.nav1'),
          a11y: this.$t('nav.nav1'),
          pathName: 'AboutMemas',
          uiLevel: this.getUiLevel()
        },
        {
          /* 2 */
          index: 0,
          name: this.$t('nav.nav2'),
          a11y: this.$t('nav.nav2'),
          pathName: 'PrivacyPage',
          uiLevel: this.getUiLevel()
        }
        /*
        {
          / * 2 * /
          index: 0,
          name: this.$t('nav.nav3'),
          a11y: this.$t('nav.nav3'),
          pathName: 'PrimaryLandingPage',
          uiLevel: this.getUiLevel()
        }
        */
      ]
    },
    logout() {
      console.log('logout got called')
      try {
        this.logoutUser().then(() => {
          // googleLogout()
          this.$router.push({
            name: 'LandingPage'
          })
        })
      } catch (error) {
        console.error(error)
      }
    }
  }
}
</script>

<style scoped>
.headerbar {
  margin-bottom: 1vh;
  height: 60px;
}

.headerbar2 {
  margin-bottom: 20vh;
  padding-bottom: 5vh;
}

.loginbutton {
  padding: 2vh 1vw 2vh 1vw;
}

.logo {
  margin-left: 2vw;
}

.logohome {
  position: relative;
  top: 1vh;
  left: 3vw;
}
.nav {
  display: flex;
  align-items: center;
}
.nav-item {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: inherit;
  text-decoration: none;
  cursor: pointer;
}
.icon {
  margin-bottom: 0.5rem;
}
.label {
  display: flex;
  font-size: 1rem;
  font-weight: var(--type-weight-medium);
  text-align: center;
  letter-spacing: 0.02em;
  text-decoration: none;
  cursor: pointer;
}

.active {
  font-weight: 800;
  font-size: 1rem;
  color: var(--color-brand-text);
}

.center {
  text-align: center;
  margin-left: auto;
  margin-right: auto;
}
</style>
